import { Component, OnInit, OnDestroy } from '@angular/core';
import { InternalMsgService } from '../services/internal.msg.service';
import { Subscription } from 'rxjs';
import { AccountService } from '../services/account.service';
import { AccountItem } from '../models/accountitem';

@Component({
    selector: 'sysadmin',
    templateUrl: './sysadmin.component.html',
    styleUrls: ['./sysadmin.component.css']
})
export class SysadminComponent implements OnInit, OnDestroy {
    visiblePage = 'sysadmin-batch-check';
    loggedAccount: AccountItem = new AccountItem();
    msgSubscr: Subscription = new Subscription();

    constructor(
        private msgService: InternalMsgService,
        private accountService: AccountService) {
    }


    ngOnInit() {
        this.msgService.onSelectedMenuSet( 4 );
        this.msgSubscr = this.msgService.loggedInAccountSet$.subscribe( 
            account => {
                this.loggedAccount = account;
            } );     
        this.accountService.fetchAccount();    
    }

    ngOnDestroy() {
        this.msgSubscr.unsubscribe();
    }

    showThis(value: string): void {
        if (value === undefined) return;
        this.visiblePage = value;
    }
}
